import PersonalEmailVerification from './PersonalEmailVerification';

export default PersonalEmailVerification;
